import * as Yup from "yup";
import { israeliMobileRegExp } from "./constants";

export const signUpValidationSchemaFull = Yup.object().shape({
  firstName: Yup.string()
    .required("השם הפרטי צריך לכלול לפחות שני תווים")
    .min(2, "השם הפרטי צריך לכלול לפחות שני תווים"),
  lastName: Yup.string()
    .required("השם משפחה צריך לכלול לפחות שני תווים")
    .min(2, "השם משפחה צריך לכלול לפחות שני תווים"),
  passport: Yup.string()
    .required("תעודת זהות צריכה להכיל 9 תווים")
    .min(9, "תעודת זהות צריכה להכיל 9 תווים")
    .max(9, "תעודת זהות צריכה להכיל 9 תווים"),
  email: Yup.string().required("אימייל לא תקין").email("אימייל לא תקין"),
  phone: Yup.string()
    .required("נא להזין מספר נייד")
    .matches(israeliMobileRegExp, "מספר נייד לא תקין"),
  birth: Yup.date()
    .required("תאריך לידה לא תקין ")
    .min(new Date(1920, 0, 1), "תאריך לידה לא תקין")
    .max(new Date(), "תאריך לידה לא תקין"),
  genderId: Yup.number().required().min(1),
  country: Yup.string().required(),
  password: Yup.string()
    .required("הסיסמה צריכה להכיל לפחות 6 תווים")
    .min(6, "הסיסמה צריכה להכיל לפחות 6 תווים"),
});
export const signUpValidationSchema1 = Yup.object().shape({
  firstName: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .min(2, "השם הפרטי צריך לכלול לפחות שני תווים"),
  lastName: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .min(2, "השם משפחה צריך לכלול לפחות שני תווים"),
  passport: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .matches(/^\d{9}$/, "תעודת זהות צריכה להכיל 9 ספרות בדיוק"),
  email: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .email("אימייל לא תקין"),
});

export const signUpValidationSchema2 = Yup.object().shape({
  phone: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .min(7, "טלפון נייד לא תקין")
    .max(7, "טלפון נייד לא תקין"),
  birth: Yup.date()
    .required("תאריך לידה לא תקין")
    .typeError("תאריך לידה לא תקין")
    .test("is-valid-date", "תאריך לידה לא תקין", (value) => {
      const minDate = new Date(1920, 0, 1);
      const maxDate = new Date();
      if (!value) return false; // Required validation
      const date = new Date(value);
      return date >= minDate && date <= maxDate; // Check if date is within range
    }),
  genderId: Yup.number().required().min(1),
  country: Yup.string().required(),
});

export const updateUserValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .min(2, "השם הפרטי צריך לכלול לפחות שני תווים"),
  lastName: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .min(2, "השם משפחה צריך לכלול לפחות שני תווים"),
  email: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .email("אימייל לא תקין"),
  phone: Yup.string().required("אנא השלם את השדות המסומנים").min(9).max(11),
  address: Yup.string().nullable(),
});

export const loginEmailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .email("אימייל לא תקין"),
  password: Yup.string()
    .required("אנא השלם את השדות המסומנים")
    .min(6, "הסיסמה צריכה להכיל לפחות 6 תווים"),
});

export const loginSMSValidationSchema = Yup.object().shape({
  phone: Yup.string()
    .required("נא להזין מספר נייד")
    .matches(israeliMobileRegExp, "מספר נייד לא תקין"),
});

export const changeAvatarValidationSchema = Yup.object()
  .shape({
    avatar: Yup.string(),
    link: Yup.string().url("קישור לא תקין"),
  })
  .test("at-least-one", "יש להעלות תמונה או להזין קישור", (values) => {
    return !!values.link || !!values.avatar; // At least one must be filled
  });

export const restorePasswordValidationSchema = Yup.object().shape({
  email_or_phone: Yup.string()
    .required('נא להזין דוא"ל או מספר נייד')
    .test("email_or_phone", "מספר נייד או אימייל לא תקין", (value) => {
      if (value.includes("@")) {
        return validateEmail(value);
      } else return /^05\d([-]?)\d{7}$/.test(value);
    }),
});

const validateEmail = (email: string) => {
  return Yup.string().email().isValidSync(email);
};

export const passwordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required("הסיסמה היא שדה חובה")
    .min(6, "הסיסמה חייבת להכיל לפחות 6 תווים")
    .matches(/[A-Za-zא-ת]/, "הסיסמה חייבת לכלול לפחות אות אחת")
    .matches(/\d/, "הסיסמה חייבת לכלול לפחות מספר אחד")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "הסיסמה חייבת לכלול לפחות תו מיוחד אחד"),

  repeatPassword: Yup.string()
    .oneOf([Yup.ref("password")], "הסיסמאות חייבות להיות זהות")
    .required("יש לאשר את הסיסמה החדשה"),
});
